import * as React from 'react';



export default class ViewMenu extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg id="views" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
       <g id="left-nav-primary-icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-236.000000, -133.000000)">
            <g id="Group-4" transform="translate(236.000000, 133.000000)">
                <g id="Group-9" transform="translate(3.000000, 3.000000)">
                    <g id="Group-2-Copy-4">
                        <path d="M1.5,18.5 L6.5,18.5 L6.5,20 L1,20 C0.44771525,20 6.76353751e-17,19.5025386 0,18.8888889 L0,1.11111111 C-6.76353751e-17,0.497461389 0.44771525,1.12725625e-16 1,0 L17,0 C17.5522847,-1.12725625e-16 18,0.497461389 18,1.11111111 L18,7.22222222 L16.5,7.22222222 L16.5,1.5 L1.5,1.5 L1.5,18.5 Z" id="Rectangle-3-Copy-7" fill="#FFFFFF" fillRule="nonzero"></path>
                        <path d="M4,5 L10.5827625,5" id="Line-2" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="square"></path>
                        <path d="M4,9.75 L5.5934278,9.75" id="Line-2-Copy" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="square"></path>
                        <path d="M4,14.75 L5.5934278,14.75" id="Line-2-Copy-2" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="square"></path>
                    </g>
                    <circle id="Oval" stroke="#FFFFFF" strokeWidth="1.5" cx="13" cy="14" r="5"></circle>
                    <path d="M16.5,17.5 L19.5,20.5" id="Line" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="square"></path>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
